<mat-dialog-content>
  <p>
    This search has produced more than 50,000 results. Would you like to
    continue with the search? Please note that it might take a while before the
    search results become available. Alternatively, you may alter the parameters
    of the order and restart production to reduce the number of results.
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close [disabled]="isSubmitting">Cancel</button>
  <button
    mat-button
    class="cdx-but-lg save"
    color="primary"
    mat-flat-button
    [disabled]="isSubmitting"
    (click)="continueSearch()"
  >
    Continue search
  </button>
</mat-dialog-actions>
